import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

import MarkdownSafeBoundary from './MarkdownSafeBoundary';
import { safeMarkdownLink } from './safeMarkdownLink';
import './SystemEvent.scss';

const REMARK_PLUGINS = [gfm];

// A quiet narration the agent posts mid-turn — an acknowledgment, a status note, or a
// delivery failure. Set apart from the conversation bubbles and rendered as markdown so its
// emphasis reads instead of showing raw asterisks. Link hrefs share the same allowlist as
// MessageBubble so prompt-injected schemes can't become clickable here either.
const SystemEvent = ({ text }) => {
  // linkReference too: reference-style links resolve through their own
  // renderer and would otherwise bypass the allowlist.
  const renderers = useMemo(() => ({ link: safeMarkdownLink, linkReference: safeMarkdownLink }), []);
  if (!text) return null;
  return (
    <div className='ap-system-event'>
      <MarkdownSafeBoundary text={text}>
        <ReactMarkdown plugins={REMARK_PLUGINS} renderers={renderers}>{text}</ReactMarkdown>
      </MarkdownSafeBoundary>
    </div>
  );
};

SystemEvent.propTypes = { text: PropTypes.string };

export default SystemEvent;
